import React from 'react';
import BookingList from './BookingList';

/*
 * Completed — pekerjaan yang sudah selesai dan diselesaikan pembayarannya.
 *
 * Tanpa `showAge`: pada daftar yang sudah selesai, "21 hari lalu" cuma derau —
 * yang relevan jam berapa pekerjaannya, bukan berapa lama sejak itu.
 * Tanpa `live` juga; riwayat tidak berubah sendiri, jadi tidak perlu menyegarkan
 * tiap 30 detik.
 */
const Completed = () => (
  <BookingList
    current="completed"
    breadcrumb={['Operations', 'Completed']}
    title="Completed jobs"
    lead="Finished and settled bookings."
    slug="completed"
    statuses="completed"
    legacyHref="/siteadmin/completed-jobs"
    emptyTitle="Nothing completed yet"
    emptyMsg="Finished jobs appear here once the provider closes them."
  />
);

export default Completed;
